import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form__body" }
const _hoisted_3 = { class: "form__footer" }
const _hoisted_4 = { class: "inner" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_language_select = _resolveComponent("language-select")!
  const _component_ui_form_field = _resolveComponent("ui-form-field")!
  const _component_ui_textfield = _resolveComponent("ui-textfield")!
  const _component_alerts_error = _resolveComponent("alerts-error")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_list_divider = _resolveComponent("ui-list-divider")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_card = _resolveComponent("ui-card")!

  return (_openBlock(), _createBlock(_component_ui_card, {
    outlined: "",
    class: "card form-wrapper"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ui_form, {
            nowrap: "",
            "item-margin-bottom": "16"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ui_form_field, null, {
                default: _withCtx(() => [
                  _createVNode(_component_language_select, { direction: 'rtl' })
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_field, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ui_textfield, {
                    modelValue: _ctx.v$.formData.title.$model,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.formData.title.$model) = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _ctx.v$.formData.title.$touch,
                    fullwidth: "",
                    placeholder: "Title",
                    class: _normalizeClass({ 'is-error': _ctx.v$.formData.title.$error })
                  }, null, 8, ["modelValue", "onBlur", "class"])
                ]),
                _: 1
              }),
              (_ctx.showKeyField)
                ? (_openBlock(), _createBlock(_component_ui_form_field, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ui_textfield, {
                        modelValue: _ctx.v$.formData.name.$model,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.formData.name.$model) = $event)),
                        modelModifiers: { trim: true },
                        onBlur: _ctx.v$.formData.name.$touch,
                        fullwidth: "",
                        placeholder: "Key",
                        class: _normalizeClass({ 'is-error': _ctx.v$.formData.name.$error })
                      }, null, 8, ["modelValue", "onBlur", "class"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.v$.formData.title.$error)
                ? (_openBlock(), _createBlock(_component_alerts_error, {
                    key: 1,
                    data: _ctx.v$.formData.title
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              (_ctx.showKeyField && _ctx.v$.formData.name.$error)
                ? (_openBlock(), _createBlock(_component_alerts_error, {
                    key: 2,
                    data: _ctx.v$.formData.name
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_ui_list_divider),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ui_button, {
              class: "btn--inline",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1)))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_ui_button, {
              class: "btn--inline",
              disabled: !_ctx.isValidInputs,
              raised: "",
              onClick: _ctx.onSave
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}